<template>
  <div class="my-info px-4">
    <h2 class="main-title">{{ lang == "en" ? "My info" : "Moji podaci" }}</h2>
    <div class="main-container">
      <v-card class="reset-password-container" elevation="0">
        <v-btn
          color="orange darken-4"
          class="mb-12 white--text"
          @click="editMyFormForm()"
          :disabled="edit"
        >
          <v-icon left dark> mdi-account-edit-outline </v-icon>
          Izmeni
        </v-btn>

        <v-form
          class="my-form-container"
          ref="myInfoForm"
          v-model="validForm"
          lazy-validation
        >
          <div>
            <v-file-input
              accept="image/png, image/jpg, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Logo"
              @change="uploadLogo"
              outlined
              dense
            ></v-file-input>
            <div class="company-logo">
              <img v-if="myInfo.logo" :src="myInfo.logo" alt="Logo" />
              <img v-else :src="require('../assets/logo-avatar.svg')" alt="Logo" />
            </div>
          </div>
          <div>
            <v-text-field
              :label="lang == 'en' ? 'Company Name' : 'Ime Komapnije'"
              v-model="myInfo.companyName"
              @keyup.enter="saveMyInfo()"
              :rules="rules.required"
              outlined
              :disabled="!edit"
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Name' : 'Ime Vlasnika'"
              v-model="myInfo.name"
              @keyup.enter="saveMyInfo()"
              :rules="rules.required"
              outlined
              :disabled="!edit"
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Surname' : 'Prezime Vlasnika'"
              v-model="myInfo.surname"
              @keyup.enter="saveMyInfo()"
              :rules="rules.required"
              :disabled="!edit"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Phone' : 'Telefon'"
              v-model="myInfo.phone"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Mobile Phone' : 'Mobilni telefon'"
              v-model="myInfo.mobilePhone"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'PIB' : 'PIB'"
              v-model="myInfo.pib"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Matični broj' : 'Matični broj'"
              v-model="myInfo.maticni"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Address' : 'Adresa'"
              v-model="myInfo.address"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'E-mail' : 'E-mail'"
              v-model="myInfo.email"
              @keyup.enter="saveMyInfo()"
              :disabled="!edit"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <div class="d-flex justify-space-between">
              <v-btn
                elevation="0"
                text color="orange darken-4"
                v-if="edit"
                @click="cancelEdit()"
              >
                {{ lang == "en" ? "Cancel" : "ODUSTANI" }}
              </v-btn>
              <v-btn
                elevation="0"
                v-if="edit"
                color="text--white teal darken-2"
                @click="saveMyInfo()"
              >
                {{ lang == "en" ? "SAVE" : "SAČUVAJ" }}
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "MyInfo",
  data() {
    return {
      validForm: false,
      edit: false,
    };
  },
  computed: {
    ...mapState(["lang", "myInfo", "snackbar", "searchForm", "IDcompany", "pageSize"]),
    ...mapGetters(["rules"]),
  },
  methods: {
    uploadLogo (file) {
      if (file) {
        var fd = new FormData()
        var fileName = ''
        var splitted = file.name.split('.')
        splitted[splitted.length - 2] = splitted[splitted.length - 2] + '____' + Date.now() + '____'
        splitted = splitted.join('.')
        fileName = splitted
        fd.append('file', file, fileName)
        this.$store.commit('loading', true)
        this.$store.dispatch('uploadLogo', fd).then((response) => {
          this.files = response
          this.$store.commit('loading', false)
        }).then(() => {
          var payload = {
            name: this.searchForm.name,
            surname: this.searchForm.surname,
            email: this.searchForm.mail,
            mobile: this.searchForm.phone,
            microChipNo: this.searchForm.chip,
            companyId: this.IDcompany,
            page: 1,
            pageSize: this.pageSize
          };
          this.$store.dispatch("getOwners", payload);
        })
      } else {
        this.files = null
        this.$store.commit('loading', true)
      }
    },
    editMyFormForm() {
      this.$store.state.myInfoClone = {...this.$store.state.myInfo}
      this.edit = true;
    },
    cancelEdit() {
      this.edit = false;
      this.$store.state.myInfo = {...this.$store.state.myInfoClone}
    },
    saveMyInfo() {
      if (this.$refs.myInfoForm.validate()) {
        this.edit = false;
        this.$store.dispatch('updateCompany', this.$store.state.myInfo)
      }
    },
  },
};
</script>

<style lang="scss">
.my-form-container {
  display: flex;
  > div:nth-child(1) {
    min-width: 250px;
    padding-left: 20px;
  }
  > div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    > div {
      flex: 0 0 40%;
      margin-left: 20px;
    }
  }
  .company-logo {
    width: 200px;
    margin: 0 auto 20px auto;
    min-height: 200px;
    background: $bg1;
    border-radius: 50%;
    position: relative;
    img {
      position: absolute;
      width: 100px;
      height: 100px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);;
    }
  }
}

@media (max-width: 768px) {
  
.my-form-container {
  display: flex;
  flex-wrap: wrap;
  > div:nth-child(1) {
    min-width: 100%;
    padding-left: 0;
  }
  > div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    > div {
      flex: 0 0 100%;
      margin-left: 0;
    }
  }
  .company-logo {
    width: 200px;
    margin: 0 auto 20px auto;
    min-height: 200px;
    background: $bg1;
    border-radius: 50%;
    position: relative;
    img {
      position: absolute;
      width: 100px;
      height: 100px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);;
    }
  }
}
}
</style>